import { PUBLISHER_FROZEN_ACTION_TOOLTIP } from '../../utils/publisherFreeze';

export interface AddDappGateInput {
  isWalletConnected: boolean;
  isPublisherFrozen: boolean;
  isPublisherVerificationApproved: boolean;
  publisherVerificationMessage: string;
  isStorageProviderConfigured: boolean;
}

export interface AddDappGate {
  /** Add/Import are blocked entirely (frozen, unverified, no wallet). */
  isBlocked: boolean;
  /** Tooltip explaining the current blocker or prerequisite, if any. */
  reason: string | null;
  /** Ready except for a storage provider → send to preferences instead. */
  needsStorageProvider: boolean;
}

export function getAddDappGate(input: AddDappGateInput): AddDappGate {
  const isBlocked =
    input.isPublisherFrozen ||
    !input.isPublisherVerificationApproved ||
    !input.isWalletConnected;
  const needsStorageProvider = !isBlocked && !input.isStorageProviderConfigured;

  const reason = input.isPublisherFrozen
    ? PUBLISHER_FROZEN_ACTION_TOOLTIP
    : !input.isPublisherVerificationApproved
      ? input.publisherVerificationMessage
      : !input.isWalletConnected
        ? 'Connect a wallet to add a dApp'
        : needsStorageProvider
          ? 'Set up a storage provider to upload dApp assets'
          : null;

  return { isBlocked, reason, needsStorageProvider };
}
